"use client";

import { datadogRum } from "@datadog/browser-rum";
import { CLM } from "@/common/schema/claims";
import { SERVICES } from "@/fe/services";

export const monitorLoggedInUser = (user: CLM.User) => {
  if (typeof window !== 'undefined' && datadogRum) {
    datadogRum.setUser({
      id: user.id.asInt.toString(),
      email: user.email,
      name: user.name,
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.roleType,
      testingTags: user.testingTags,
      setting: user.settings,
      experimentalSettings: user.experimentalSettings,
      impersonating: {
        ...user.impersonating,
        id: user.impersonating?.id.asInt.toString(),
        experimentalSettings: undefined
      }
    });
    datadogRum.startSessionReplayRecording();
  }
};

export const endMonitorLoggedInUser = () => {
  if (typeof window !== 'undefined' && datadogRum) {
    datadogRum.stopSessionReplayRecording();
    datadogRum.stopSession();
  }
};

export default function RumUserProvider({ children }:
{
  children?: React.ReactNode
}) {
  const { CTX } = SERVICES();
  const isLoggedIn = CTX.useIsLoggedIn();

  if(isLoggedIn) {
    const { superUser, currentUser } = CTX.useLoggedInContext();

    monitorLoggedInUser(superUser ?? currentUser);
  }

  return children;
}
